export default {
    cache : {},
    events : {},
    global : {},
    messages : [],
    promises : {},
    states : {},
    translations : {},
}
